import { Vector } from '@moleculeone/types';

interface GradientProps {
  id: string;
  pos1: Vector;
  pos2: Vector;
  col1: string;
  col2: string;
}

export function Gradient(props: GradientProps) {
  const { id, pos1, pos2, col1, col2, ...restProps } = props;

  return (
    <linearGradient
      gradientUnits="userSpaceOnUse"
      x1={pos1[0].toFixed(2)}
      y1={pos1[1].toFixed(2)}
      x2={pos2[0].toFixed(2)}
      y2={pos2[1].toFixed(2)}
      id={id}
      {...restProps}
    >
      <stop offset="0%" key="a" stopColor={col1} />
      <stop offset="49.5%" key="b" stopColor={col1} />
      <stop offset="50.5%" key="c" stopColor={col2} />
      <stop offset="100%" key="d" stopColor={col2} />
    </linearGradient>
  );
}
